// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FAQ-page {

    min-height: 938px;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding-top: 50px;
    padding-bottom: 50px;
}

.faq-container {
    max-width: 1000px;
    margin: 0 auto;
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
}

.faq-card {
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    position: relative;
    display: flex;
    background-color: #f9f9f9;
}



.answer {
    width: 100%;
    box-sizing: border-box;
    text-align: left;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 0px;
}

.question {
    width: 100%;
    font-weight: bold;
    text-align: left;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 0px;
}




.line-divider {
    width: 2px;

    background-color: #ccc;
    margin: 10px;

    /* Adjust the margin as needed */
}

/* Optional: Add styling for better visual appeal */
.faq-card {
    max-width: 900px;
    border: 1px solid #ccc;
    margin-bottom: 20px;
    border-radius: 8px;
    min-height: 300px;
    background-color: #f9f9f9;
    overflow: hidden;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.8);
    padding: 20px;
}

.sub-sections {
    max-width: 900px;

    margin-bottom: 20px;
    border-radius: 8px;


    overflow: hidden;

    padding: 20px;
}

.FAQ-title {
    margin-bottom: 50px;
}`, "",{"version":3,"sources":["webpack://./src/pages/FAQ.css"],"names":[],"mappings":"AAAA;;IAEI,iBAAiB;;IAEjB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,yBAAyB;AAC7B;;;;AAIA;IACI,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;;;;AAKA;IACI,UAAU;;IAEV,sBAAsB;IACtB,YAAY;;IAEZ,gCAAgC;AACpC;;AAEA,mDAAmD;AACnD;IACI,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;IAChB,uCAAuC;IACvC,aAAa;AACjB;;AAEA;IACI,gBAAgB;;IAEhB,mBAAmB;IACnB,kBAAkB;;;IAGlB,gBAAgB;;IAEhB,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".FAQ-page {\n\n    min-height: 938px;\n\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding-top: 50px;\n    padding-bottom: 50px;\n}\n\n.faq-container {\n    max-width: 1000px;\n    margin: 0 auto;\n    padding: 20px;\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.faq-card {\n    width: 100%;\n    box-sizing: border-box;\n    padding: 10px;\n    position: relative;\n    display: flex;\n    background-color: #f9f9f9;\n}\n\n\n\n.answer {\n    width: 100%;\n    box-sizing: border-box;\n    text-align: left;\n    padding-left: 10px;\n    padding-right: 10px;\n    padding-top: 0px;\n}\n\n.question {\n    width: 100%;\n    font-weight: bold;\n    text-align: left;\n    padding-left: 10px;\n    padding-right: 10px;\n    padding-top: 0px;\n}\n\n\n\n\n.line-divider {\n    width: 2px;\n\n    background-color: #ccc;\n    margin: 10px;\n\n    /* Adjust the margin as needed */\n}\n\n/* Optional: Add styling for better visual appeal */\n.faq-card {\n    max-width: 900px;\n    border: 1px solid #ccc;\n    margin-bottom: 20px;\n    border-radius: 8px;\n    min-height: 300px;\n    background-color: #f9f9f9;\n    overflow: hidden;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.8);\n    padding: 20px;\n}\n\n.sub-sections {\n    max-width: 900px;\n\n    margin-bottom: 20px;\n    border-radius: 8px;\n\n\n    overflow: hidden;\n\n    padding: 20px;\n}\n\n.FAQ-title {\n    margin-bottom: 50px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
